module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree-container"
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.data,
      "props": _vm.defaultProps
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.clickNode))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd99e85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/tree1.vue
// module id = 120
// module chunks = 1